import type { ReactNode } from 'react'

export function ExternalLink({
  href,
  children,
  className = '',
}: {
  href: string
  children: ReactNode
  className?: string
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`text-crt-lime underline decoration-crt-lime/40 underline-offset-2 hover:decoration-crt-lime ${className}`}
    >
      {children}
      <span aria-hidden="true" className="ml-0.5 text-[10px]">
        ↗
      </span>
    </a>
  )
}
